import gql from 'graphql-tag'
import { customTagLabelFragment, customTagFragment } from '@/graphql/tag/tagFragments'
import { tagFragment } from '@/graphql/tag/tagFragments'

export const TAGS = gql`
    query tags(
        $type: TagTypes!
    ) {
        tags(
            type: $type
        ) {
            ...tagFragment
        }
    }
    ${tagFragment}
`
// export const TAGSSEARCH = gql`
//     query tagsSearch(
//         $type: TagTypes!
//         $searchText: String
//     ) {
//         tagsSearch(
//             searchText: $searchText
//             type: $type
//         ) {
//             data{
//                 ...tagFragment
//             }
//         }
//     }
//     ${tagFragment}
// `
export const PROFESSIONS = gql`
    query professions(
        $trashed: Trashed
    ) {
        professions (
            trashed: $trashed
        ){
            ...tagFragment
        }
    }
    ${tagFragment}
`

export const SKILLS = gql`
    query skills(
        $trashed: Trashed
    ) {
        skills (
            trashed: $trashed
        ){
            ...tagFragment
        }
    }
    ${tagFragment}
`

export const COURSES = gql`
    query courses(
        $trashed: Trashed
    ) {
        courses (
            trashed: $trashed
        ){
            ...tagFragment
        }
    }
    ${tagFragment}
`

export const CUSTOMTAGS = gql`
    query customTags(
        $customtag_label_id: ID
        $trashed: Trashed
    ){
        customTags(
            label_id: $customtag_label_id
            trashed: $trashed
        ) {
            ...customTagFragment
        }
    }
    ${customTagFragment}
`

export const CUSTOMTAGLABELS = gql`
    query customTagLabels(
        $trashed: Trashed
    ) {
        customTagLabels(
            trashed: $trashed
        ) {
            ...customTagLabelFragment
        }
    }
    ${customTagLabelFragment}
`

export const CUSTOMTAGLABELSTAGS = gql`
    query customTagLabels(
        $model: ApplyToModels
        $trashed: Trashed
    ){
        customTagLabels(
            model: $model
            trashed: $trashed
        ) {
            ...customTagLabelFragment
            tags{
                ...tagFragment
                label{
                    id
                    name
                }
            }
        }
    }
    ${customTagLabelFragment}
    ${tagFragment}
`

export const APPLYTOMODELS = gql`
    query {
        __type(name: "ApplyToModels"){
            enumValues{
                name
                description
            }
        }
    }
`